<template>
    <div class="w-full max-w-2xl">
        <div class="bg-base-100 shadow-xl rounded-xl p-4">
            <div class="flex items-center gap-2">
                <div
                    v-for="macro in macroStats"
                    :key="macro.key"
                    class="flex flex-col items-center gap-1 flex-1"
                >
                    <div class="relative w-full aspect-square max-w-[50px] xs:max-w-[70px] sm:max-w-[80px]">
                        <canvas :data-key="macro.key"></canvas>
                        <div class="absolute inset-0 flex items-center justify-center">
                            <span class="text-sm font-medium">{{ macro.pct }}%</span>
                        </div>
                    </div>
                    <span class="text-xs text-base-content/50">{{ macro.label }}</span>
                    <span class="text-xs font-medium">{{ macro.grams }}g</span>
                </div>
                <div class="flex flex-col items-center justify-center flex-1">
                    <span class="text-lg font-bold">{{ summary.total_calories }}</span>
                    <span class="text-xs text-base-content/40">kcal</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js/auto';

const MACROS = [
    { key: 'total_protein', label: 'Protein', kcalPerG: 4, color: '#378ADD' },
    { key: 'total_carbs', label: 'Carbs', kcalPerG: 4, color: '#EF9F27' },
    { key: 'total_fat', label: 'Fat', kcalPerG: 9, color: '#D85A30' },
    { key: 'total_fiber', label: 'Fiber', kcalPerG: 2, color: '#1D9E75' },
];

export default {
    name: 'DailySummary',
    props: {
        summary: {
            type: Object,
            required: true,
        },
    },
    charts: null,
    computed: {
        totalGrams() {
            return MACROS.reduce((sum, m) => sum + (this.summary[m.key] || 0), 0);
        },
        macroStats() {
            return MACROS.map((m) => {
                const grams = this.summary[m.key] || 0;
                const pct = this.totalGrams > 0 ? Math.round((grams / this.totalGrams) * 100) : 0;
                return { ...m, grams, pct };
            });
        },
    },
    watch: {
        macroStats() {
            this.updateCharts();
        },
    },
    mounted() {
        this.charts = {};
        this.macroStats.forEach((macro) => {
            const canvas = this.$el.querySelector(`canvas[data-key="${macro.key}"]`);
            this.charts[macro.key] = new Chart(canvas, {
                type: 'doughnut',
                data: {
                    datasets: [
                        {
                            data: [macro.pct, 100 - macro.pct],
                            backgroundColor: [macro.color, 'oklch(var(--b2))'],
                            borderWidth: 0,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,

                    cutout: '68%',
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false },
                    },
                    animation: { animateRotate: true },
                },
            });
        });
    },
    beforeUnmount() {
        Object.values(this.charts).forEach((c) => c.destroy());
        this.charts = null;
    },
    methods: {
        updateCharts() {
            if (!this.charts) return;
            this.macroStats.forEach((macro) => {
                const chart = this.charts[macro.key];
                chart.data.datasets[0].data = [macro.pct, 100 - macro.pct];
                chart.update();
            });
        },
    },
};
</script>
